import { useSelector } from 'react-redux';
import { AdsPerExistingRealties } from './adsPerExistingRealties';
import { AveragePricePerSqMt } from './averagePricePerSqMt';
import { RealtyAnnouncedByPeriod } from './realtyAnnouncedByPeriod';
import './secondaryCharts.scss';

const SecondaryCharts: React.FC = () => {
  const { isGridView } = useSelector((state: any) => state.chartsState);

  return (
    <div className={`secondary-charts ${isGridView ? '' : 'list-layout'}`}>
      <RealtyAnnouncedByPeriod />
      <AdsPerExistingRealties />
      <AveragePricePerSqMt />
    </div>
  );
};

export default SecondaryCharts;
